<template>
  <div class="flex gap-2 w-full mb-4">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      :class="[
        'flex-1 py-2 rounded-md font-medium transition',
        selectedTab === tab.value
          ? 'bg-primary-purple text-white shadow'
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200',
      ]"
      @click="$emit('tab-change', tab.value)"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "InviteTabs",
  props: {
    selectedTab: {
      type: String as PropType<"manual" | "bulk" | "link" | "software">,
      required: true,
    },
  },
  data() {
    return {
      tabs: [
        { label: "Manual", value: "manual" },
        { label: "Bulk", value: "bulk" },
        { label: "Invite via link", value: "link" },
        { label: "Invite via software", value: "software" },
      ],
    };
  },
});
</script>
